import { Constants, PhoneCallAttributes } from '@salesforce/scv-connector-base';

export class PhoneCallAttributesGenerator {
  static generate(): PhoneCallAttributes {
    return new PhoneCallAttributes({
      participantType: Constants.PARTICIPANT_TYPE.INITIAL_CALLER,
      isOnHold: false,
      dialerType: Constants.DIALER_TYPE.NONE,
      hasSupervisorBargedIn: false,
    });
  }
}
